import { DOCUMENT, inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';

const MANIFEST_REL = 'manifest';

@Injectable({ providedIn: 'root' })
export class PortalManifestService {
  private readonly document = inject(DOCUMENT);

  apply(tenantHash: string | null): void {
    const link = this.document.querySelector<HTMLLinkElement>(`link[rel="${MANIFEST_REL}"]`);

    if (!tenantHash) {
      link?.remove();
      return;
    }

    const href = `${environment.workflowApiUrl}/tenant/manifest?t=${encodeURIComponent(tenantHash)}`;
    const target = link ?? this.createLink();
    target.crossOrigin = 'anonymous';
    target.href = href;
  }

  private createLink(): HTMLLinkElement {
    const link = this.document.createElement('link');
    link.rel = MANIFEST_REL;
    this.document.head.appendChild(link);
    return link;
  }
}
